
const digest = 'f102599aa4a280cff1220f0535642cf092cc0409df28dbae5872d9463a81211e';
const css = `._searchComponent_1syzi_1 {
  overflow: hidden;
}

._emoji_1syzi_5 {
  font-size: 16px;
}

._shortcode_1syzi_9 {
  position: relative;
  top: -1px;
  margin-left: 5px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"searchComponent":"_searchComponent_1syzi_1","emoji":"_emoji_1syzi_5","shortcode":"_shortcode_1syzi_9"};
export { css, digest };
  